import jwtDecode from 'jwt-decode'
import moment from 'moment'
export default {
    isJwtExpired(jwtToken) {
        try {
            const decodedJwtToken = jwtDecode(jwtToken)
            const jwtTokenExpirationTime = decodedJwtToken.exp
            return moment().unix() > jwtTokenExpirationTime
        } catch {
            return true
        }
    },
    isHmac512(jwtToken) {
        let headers
        try {
            headers = jwtDecode(jwtToken, { header: true })
        } catch {
            return false
        }
        return headers.alg === 'HS512'
    },
    isValid(jwtToken) {
        if (!jwtToken) {
            return false
        }
        return !this.isJwtExpired(jwtToken) && this.isHmac512(jwtToken)
    }
}
